// lib
import React, { memo, ReactElement, useCallback } from "react";

//internal deps
import { DeliveryInstructionDetail } from "@swiggy-private/cart-types";
import { DELIVERY_INSTRUCTION_WIDGET_TEST_IDS } from "@swiggy-private/cart-test-ids";

//components
import { DisplayText, EditCrossIcon, InstructionBoxContainer, IconWrapper } from "./deliveryInstructionsItem.styles";
import { SpriteIconWeb } from "@swiggy-private/dls-web-icons/dist/SpriteIconWeb";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";

//helpers
import { isPopFlow } from "@swiggy-private/checkout-core";

export interface DeliveryInstructionItemProps {
    data: DeliveryInstructionDetail;
    onDeliveryInstructionItemClick?: (e: React.MouseEvent) => void;
}

const ICON_WIDTH = "26px";
const ICON_HEIGHT = "27px";
const DIRECTIONS_TO_REACH_TYPE = "INSTRUCTION_TYPE_REACH";
const UNSELECT_TEXT = "Click to unselect";
const SELECT_TEXT = "Click to select";

const DeliveryInstructionItem = ({
    data,
    onDeliveryInstructionItemClick,
}: DeliveryInstructionItemProps): ReactElement => {
    const {
        id,
        title,
        selected,
        active_icon_url_id: activeIconUrlId,
        inactive_icon_url_id: inactiveIconUrlId,
        instruction_type: instructionType,
    } = data;

    const isPopCart = isPopFlow();

    const onDeliveryInstructionClick = useCallback(
        (event: React.MouseEvent) => {
            typeof onDeliveryInstructionItemClick === "function" && onDeliveryInstructionItemClick(event);
        },
        [onDeliveryInstructionItemClick],
    );

    return (
        <InstructionBoxContainer
            data-testid={`${DELIVERY_INSTRUCTION_WIDGET_TEST_IDS.DELIVERY_INSTRUCTION_ITEM}_${id}`}
            onClick={onDeliveryInstructionClick}
            aria-label={selected ? `${UNSELECT_TEXT} ${title} ` : `${SELECT_TEXT} ${title} `}
            role="button"
            isSelected={selected}
            isPopCart={isPopCart}
        >
            {selected && instructionType !== DIRECTIONS_TO_REACH_TYPE && (
                <EditCrossIcon as="span">
                    <SpriteIconWeb iconName="close12" fillColor={!isPopCart ? "primary" : "text_Highest_Emphasis"} />
                </EditCrossIcon>
            )}

            {selected && instructionType === DIRECTIONS_TO_REACH_TYPE && (
                <EditCrossIcon as="span">
                    <SpriteIconWeb iconName="modify12" fillColor={!isPopCart ? "primary" : "text_Highest_Emphasis"} />
                </EditCrossIcon>
            )}
            <IconWrapper as="div">
                <Image
                    cloudinaryId={selected ? activeIconUrlId : inactiveIconUrlId}
                    alt={title}
                    crossOrigin="anonymous"
                    height={ICON_HEIGHT}
                    width={ICON_WIDTH}
                    fit="cover"
                />
            </IconWrapper>
            <DisplayText
                aria-hidden="true"
                variant="V2.body3.neutral.medium"
                color={selected ? "text_Highest_Emphasis" : "text_Med_Emphasis"}
                maxLines={2}
            >
                {title}
            </DisplayText>
        </InstructionBoxContainer>
    );
};

export default memo(DeliveryInstructionItem);
